<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="司机姓名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.driverName" placeholder="请输入司机姓名"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户联系电话"></el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="searchInfo.status" class="big" placeholder="请选择状态" clear>
							<el-option :key="0" label="离职" :value="0">离职</el-option>
							<el-option :key="1" label="在职" :value="1">在职</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="性别" class='tiny'>
						<el-select v-model="searchInfo.sex" class="big" placeholder="请选择性别" clear>
							<el-option :key="0" label="男" :value="0">男</el-option>
							<el-option :key="1" label="女" :value="1">女</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="灵活员工" class='tiny'>
						<el-select v-model="searchInfo.isFlexibleEmployment" class="big" placeholder="请选择" clear>
							<el-option :key="-1" label="全部" :value="-1">全部</el-option>
							<el-option :key="0" label="公司员工" :value="0">公司员工</el-option>
							<el-option :key="1" label="灵活用工" :value="1">灵活用工</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
							<el-button type="primary" @click="adduser"> 新增 </el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			
			<el-table-column prop="id" label="用户ID" sortable align="center" width="90">
			</el-table-column>
			<el-table-column prop="driverName" label="姓名" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="photoImages" label="个人照片" align="center" :formatter="changeNull">
				<template slot-scope="scope">
					<img :src="scope.row.photoImages" style="width: 50px;height: 50px;border-radius: 50%;" />
				</template>
			</el-table-column>
			<el-table-column prop="idcardImages" label="证件照片" align="center" :formatter="changeNull">
				<template slot-scope="scope">
					<span @click="lookzj(scope.row.idcardImages)">查看</span>
				</template>
			</el-table-column>
			<el-table-column prop="phone" label="联系电话" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="sex" label="性别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.sex == 0">男</div>
					<div v-if="scope.row.sex == 1">女</div>
					</template>
			</el-table-column>
			<el-table-column prop="carNumberplate" label="关联车牌" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" width="80">
				<template slot-scope="scope">
					<p v-if="!scope.row.status">离职</p>
					<p v-else style="color: green;">在职</p>
				</template>
			</el-table-column>
			<el-table-column prop="isFlexibleEmployment" label="是否灵活用工" align="center" width="120">
				<template slot-scope="scope">
					<p v-if="scope.row.isFlexibleEmployment==1">灵活用工</p>
					<p v-else style="color: green;">公司员工</p>
				</template>
			</el-table-column>
			
			<el-table-column prop="createTime" label="注册时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center">
				　　　　<template slot-scope="scope">
					　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">
						编辑</el-button>
						<el-button size="small" type="text" @click="toDelete(scope.row.id)">
							删除</el-button>
				</template>
				
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="userList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="userList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		
		<!-- 新增联系人 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisibleuser" width="40%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="姓名"  label-width="120px">
							<el-input type="text" clearable v-model="userInfo.driverName" placeholder="请输入驾驶人名称" />
						</el-form-item>
						<el-form-item label="联系电话"  label-width="120px">
							<el-input type="text" clearable v-model="userInfo.phone" placeholder="请输入联系电话" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="性别"  label-width="120px">
							 <el-select v-model="userInfo.sex"  placeholder="请选择性别" clear style="width: 200px;">
							 	<el-option :key="0" label="男" :value="0">男</el-option>
							 	<el-option :key="1" label="女" :value="1">女</el-option>
							 </el-select>
						</el-form-item>
						<el-form-item label="在职状态" label-width="120px" style="display: flex;align-items: center;
							justify-content: flex-start;">
							
							 <el-switch
								v-model="userInfoStatus"
								:active-value="1" :inactive-value="0">
							</el-switch>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
					<!-- 	<el-form-item label="关联车牌"  label-width="120px">
							<el-input type="text" style="width: 200px;" clearable v-model="userInfo.carNumberplate" placeholder="请输入关联车牌" />
						</el-form-item> -->
						<el-form-item label="关联车辆" label-width="120px" class='tiny'>
							<el-select style="width: 200px;" filterable v-model="userInfo.carNumberplate" class="big" placeholder="请选择" clear>
								<el-option v-for="it in arsList" :key="it.id" :value="it.carNumberplate"
									:label="it.carNumberplate"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="是否为灵活用工" label-width="120px" style="display: flex;align-items: center;
							justify-content: flex-start;">
							<!-- label="是否为灵活用工" -->
							 <!-- <el-select v-model="userInfo.isFlexibleEmployment"  placeholder="请选择" clear style="width: 100%;">
							 	<el-option :key="false" label="公司员工" :value="false">公司员工</el-option>
							 	<el-option :key="true" label="灵活用工" :value="true">灵活用工</el-option>
							 </el-select>		 -->
							  <el-switch
								v-model="isFlexibleEmployment"
								:active-value="1" :inactive-value="0">
							</el-switch>
						</el-form-item>
						<!-- <el-form-item label="关联车牌"  label-width="120px">
							<el-input type="text" style="width: 100%;"
								v-model="userInfo.carNumberplate" placeholder="请输入关联车牌" />
						</el-form-item> -->
						
					</div>
				
						<div style="display: flex;align-items: center;margin-left: 50px;">
							<el-form-item label="个人照片" >
								<br />
								<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview1"
									:on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" :limit='1'
									:on-success="onSuccess1">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;margin-left: 50px;">
						<el-form-item label="证件照片" >
							<br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
						</div>
					
					
		
				</el-form>
			</div>
			<div style="text-align: center;margin-top: 100px;">
				<el-button @click="dialogVisibleuser = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增司机'" type="primary" @click="add">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑司机'" type="primary" @click="sure">编 辑</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false">
			<el-carousel indicator-position="outside" style="height: 600px;">
				<el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
					<img :src="item" style="width: 100%; height: 100%;" />
				</el-carousel-item>
			</el-carousel>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		data() {
			return {
				userInfo:{},
				loading: false,
				dialogVisibleImg:false,
				dialogImageUrl:[],
				remark:'',
				fileList: [],
				fileList1: [],
				userList: [{}], //用户列表
				propertyDialogVisible: false,
					httpUrl: urls,
				inviteDialogVisible: false,
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName:'',
				editUserDialogVisible: false, // 编辑用户弹窗
				editAgentDialogVisible: false, // 设置代理弹窗
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				form: {
					username: "",
					password: "",
					surePass: "",
					userLevel: "",
					userLevel: "",
					vipLevel: "",
				},
				userPropertyList: [],
				mainFormRules: {
					username: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
				},
				userPropertyListFl: [],
				goodsImages: [],
				photoImages:'',
				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10,
					FlPageNum: 1,
					FlPageSize: 10
				},
				editPassword: false,
				searchInfo: {},
				inviteData: [],
				//设置代理弹窗
				dialogVisibleuser:false,
				setTLevelDialogVisible: false,
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
				},
				setTLevelDataList: [],
				FLDialogVisible: false,
				agentCount: 0,
				arsList:[],
				userForm: {},
				logo: "",
				province: [],
				city: [],
				area: [],
				flag: 0,
				userInfoStatus: 1,
				isFlexibleEmployment: 1,
			};
		},
		methods: {
			//提交充值
			sure() {
				this.loading = true
			
				let data = {
					...this.userInfo,
					isFlexibleEmployment: this.isFlexibleEmployment,
					status: this.userInfoStatus,
					idcardImages:this.goodsImages.join(','),
					photoImages:this.photoImages
				}
			
				this.$api.updriverlist(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
					} else {
						this.$message.error(res.message);
					}
					this.loading = false
					this.dialogVisibleuser = false;
				})
			},
			lookzj(img){
				this.dialogImageUrl=img.split(',')
				this.dialogVisibleImg=true
			},
			add(){
				// console.log(this.goodsImages);
				let data={
					...this.userInfo,
					isFlexibleEmployment: this.isFlexibleEmployment,
					status: this.userInfoStatus,
					idcardImages:this.goodsImages.join(','),
					photoImages:this.photoImages
				}
				this.$api.adddriverlist(this.$encrypt(data)).then(res=>{
						if(res.state=='success'){
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogVisibleuser = false;
							this.userInfo={}
							this.getUserList();
						}
				})
			},
			adduser(){
				this.userInfo={}
				this.goodsImages=[]
				this.fileList=[]
				this.fileList1=[]
				this.photoImages=''
				this.dialogVisibleFunName='新增司机'

				this.dialogVisibleuser=true
			},
			// 编辑弹窗
			dialogVisibleFun(id) {
				this.goodsImages=[]
				this.fileList=[]
				this.fileList1=[]
				this.photoImages=''
					this.$api.driverById(id).then(res=>{
						res.data=JSON.parse(this.$decrypt(res.data)).data
						this.userInfo = res.data;
						this.isFlexibleEmployment = res.data.isFlexibleEmployment;
					    this.userInfoStatus = res.data.status;
						this.fileList1.push({
							url: res.data.photoImages
						})
						let imagesArray = res.data.idcardImages.split(',')
						// console.log(imagesArray);
						for (let i = 0; i < imagesArray.length; i++) {
							this.fileList.push({
								name: imagesArray[i],
								url:imagesArray[i]
							
							})
						}
						
						this.photoImages=res.data.photoImages
						// console.log(this.fileList1,this.fileList);
						this.goodsImages=res.data.idcardImages.split(',')
					})
				this.dialogVisibleuser=true
				this.dialogVisibleFunName='编辑司机'
			
			},
			//导出
			downloadFile() {
				let data = {
					...this.searchInfo
				};
				// console.log(data);
				this.$api.driverListExportExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "司机列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			
			handleProvinceId(item) {
				// console.log(isNaN(item.name),item)
				if (isNaN(item.name)) {
					this.$api.getArea(item.id).then((res) => {
						this.city = res.data
					});
				} else if (isNaN(item.name) == false) {
					this.$api.getArea(item.name).then((res) => {
						this.city = res.data
					});
				}

				this.setTLevelData.data[0] = item
				// this.setTLevelData.provinceId.id=item.id
			},
			handleCityId(item) {
				// console.log(isNaN(item.name),item)
				if (isNaN(item.name)) {
					// this.$api.getArea(item.id).then((res) => {
					// 	this.area = res.data
					// });
				} else if (isNaN(item.name) == false) {
					this.$api.getArea(item.name).then((res) => {
						this.area = res.data
					});
				}

				this.setTLevelData.data[1] = item
				// this.setTLevelData.cityId.id=item.id
			},
			handleAreaId(item) {
				// console.log(item)
				this.setTLevelData.data[2] = item
				// this.setTLevelData.areaId.id=item.id
			},
		
			
			toEditPassword(id) {
				this.form.password = "";
				this.form.surePass = "";
				this.ids = id;
				this.editDialogVisible = true;
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},
			findSysUserById(id) {
				this.$api.findSysUserById(id).then((res) => {
					if (res.state == 'success') {
						this.form.username = res.data.username
					}
				})
			},
			cannelPass() {
				this.editDialogVisible = false
				this.loading = false
			},
			showEditAgentDialogVisible(id) {
				this.editAgentDialogVisible = true
				this.userForm = {}
				this.setTLevelData = {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: []
				}
				this.$api.getUserInfoById({
					id: id
				}).then((res) => {
					if (res.state == 'success') {
						this.userForm = res.data
						// this.logo = res.data.logo
					}
				})
				this.$api.findUserArea({
					id: id
				}).then((respon) => {
					if (respon.state === "success") {
						this.setTLevelData.userId = id
						if (respon.data.UserArea) {
							this.flag = 1
							this.setTLevelData.agentLevel = respon.data.UserArea.agentLevel
							this.setTLevelData.status = respon.data.UserArea.status
							this.setTLevelData.id = respon.data ? respon.data.UserArea.id : ""
							this.setTLevelData.provinceId = respon.data.area[0] ? respon.data.area[
								0] : ""
							this.setTLevelData.cityId = respon.data.area[1] ? respon.data.area[1] :
								""
							this.setTLevelData.areaId = respon.data.area[2] ? respon.data.area[2] :
								""
							this.setTLevelData.data[0] = respon.data.area[0]
							this.setTLevelData.data[1] = respon.data.area[1]
							this.setTLevelData.data[2] = respon.data.area[2]
							this.$forceUpdate()
							// console.log(this.setTLevelData)
							if (this.setTLevelData.provinceId) {
								this.$api.getArea(respon.data.area[0].id).then((res) => {
									this.city = res.data
								});
							}
							if (this.setTLevelData.cityId) {
								this.$api.getArea(respon.data.area[1].id).then((res) => {
									this.area = res.data
								});

							}
							this.$forceUpdate()
						} else {
							this.setTLevelData = {
								agentLevel: "",
								provinceId: {
									name: "",
									id: ""
								},
								cityId: {
									name: "",
									id: ""
								},
								areaId: {
									name: "",
									id: ""
								},
								status: false,
								userId: "",
								id: "",
								data: []
							}
							this.flag = 0
						}
						this.$forceUpdate()
						// console.log(this.setTLevelData)
					}
				})
			},
			showEditUserDialogVisible(id) {
				this.userForm = {}
				this.ids = id
				this.editUserDialogVisible = true
				this.$api.getUserInfoById({
					id: id
				}).then((res) => {
					if (res.state == 'success') {
						this.userForm = res.data
						this.logo = res.data.logo
				
					}
				})
			},
			onSuccess1(response, file, fileList) {
				// console.log(res)
				this.photoImages=response.message;
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview1(file) {
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			onSuccess(response, file, fileList) {
					// console.log("asda",response,this.goodsImages)
				this.goodsImages.push(response.message);
			
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.logo = res.data
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//重置密码弹框
			editialogVisible(id) {
				this.form.password = ""
				this.form.surePass = ""
				this.ids = id
				this.editPassword = true;
			},

			
			
			//删除
			toDelete(row) {
			
					var str = "确认删除该司机, 是否继续?"
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.deleteByID(row).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time
						.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				
				}
				this.$api.driverlist(this.$encrypt(data)).then((res) => { //角色管理列表
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.userList = res.data
						this.loading = false
					}
				})
			},
			toShowProperty(userId) {
				this.userPropertyList = []
				this.propertyDialogVisible = true
				this.$api.getUserProperty({
					pageNum: 1,
					pageSize: 20,
					userId: userId
				}).then((res) => { //角色管理列表
					// console.log('角色管理列表:', res);
					if (res.state == 'success') {
						this.userPropertyList = res.data.list
					}
				})

			},
			toShowInvite(userId) {
				this.inviteData = []
				this.ids = userId
				this.inviteDialogVisible = true
				this.showInvite(userId);
			},
			toShowPropertyFl(userId) {
				this.userPropertyListFl = []
				this.ids = userId
				this.FLDialogVisible = true
				this.showFl(userId);
			},
			showFl(userId) {
				this.loading = true
				let data = {
					userId: this.ids,
					pageNum: this.page.FlPageNum,
					pageSize: this.page.FlPageSize,
				}
				this.$api.findFlowRecord(data).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.userPropertyListFl = res.data
					}
					this.loading = false
				})
			},
			pageFlChange(data) {
				this.page.FlPageNum = data
				this.showFl(this.ids)
			},
			handleFlSizeChange(val) {
				this.page.FlPageSize = val
				this.showFl(this.ids)
			},
			pageInviteChange(data) {
				this.page.invitePageNum = data
				this.showInvite(this.ids)
			},
			handleInviteSizeChange(val) {
				this.page.invitePageSize = val
				this.showInvite(this.ids)
			},
			showInvite(userId) {
				this.loading = true
				let data = {
					id: this.ids,
					pageNum: this.page.invitePageNum,
					pageSize: this.page.invitePageSize,
				}
				this.$api.showInvite(data).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.inviteData = res.data
					}
					this.loading = false
				})
			}

		},
		created() {
			this.$api.fcarsList(this.$encrypt({})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.arsList = res.data
			})
			
			this.getUserList();
			this.Area()
			this.$api.getIntegralList({
				isCharge: 1
			}).then((res) => {
				if (res.state == 'success') {
					this.integralList = res.data
				}
			})
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
